import React from 'react';
import { transformHTMLParserLinks } from '../../../../utils/rewriteLink/rewriteLink';
import { Icon, Title } from '../../../../importCL';
import { useWidthContext } from '../../../../providers/Width';

interface IIcon {
    iconLabel: string;
    iconPath: string;
    iconAltText: string;
    uuid: string;
}

export interface IContactInformation {
    icon?: null | IIcon;
    firstTitle?: string;
    firstDescription?: string;
    secondTitle?: string;
    secondDescription?: string;
}

export interface IContactFooterProps {
    backgroundImage?: string;
    title?: string;
    contactInformation?: Array<IContactInformation>;
}

export default function ContactFooter({ backgroundImage, title, contactInformation }: IContactFooterProps) {
    const { width } = useWidthContext();
    
    return (
        <div className='FaqMenu__contactFooter flex flex-row md:flex-col mt-10 md:mt-8'>
            <img className='FaqMenu__contactFooterBackgroundImage md:max-h-[23.438rem]' src={backgroundImage}/>
            <div className='FaqMenu__contactInformation flex flex-col'>
                <div className='FaqMenu__contactInformationContainer'>
                    <Title className='FaqMenu__contactTitle' verticalBar>
                        {transformHTMLParserLinks(title)}
                    </Title>
                    {contactInformation?.length > 0 && contactInformation.map((contactItem, index) => {
                        return(
                            <div className={`FaqMenu__contactItem${index != contactInformation.length - 1 ? '--bottomBorder' : ''} flex flex-row `}>
                                <Icon src={contactItem?.icon?.iconPath} customSize={width >= 769 ? 64 : 40}/>
                                <div className='FaqMenu__contactItemInformation flex flex-row md:flex-col'>
                                    <div className='FaqMenu__leftContactItem'>
                                        <div className='FaqMenu__contactDescription md:flex md:flex-col'>
                                            <div className='FaqMenu__contactItemTitle'>
                                                {transformHTMLParserLinks(contactItem?.firstTitle)}
                                            </div>
                                            <div className='FaqMenu__contactItemDescription'>
                                                {transformHTMLParserLinks(contactItem?.firstDescription)}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='FaqMenu__rightContactItem'>
                                        <div className='FaqMenu__contactDescription'>
                                            <div className='FaqMenu__contactItemTitle'>
                                                {transformHTMLParserLinks(contactItem?.secondTitle)}
                                            </div>
                                            <div className='FaqMenu__contactItemDescription'>
                                                {transformHTMLParserLinks(contactItem?.secondDescription)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );     
                    })}
                </div>
            </div>
        </div>
    );
}